"use client";

import { css } from "styled-components";

const getURL = (font: string) => `https://cdn.faire.com/static/fonts/${font}`;

export const BigCaslon = css`
  @font-face {
    font-family: "Big Caslon";
    font-style: normal;
    font-weight: 400;
    src: url("${getURL("Big+Caslon+Regular.woff2")}") format("woff2"),
      url("${getURL("Big+Caslon+Regular.woff")}") format("woff");
  }

  @font-face {
    font-family: "Big Caslon";
    font-style: italic;
    font-weight: 400;
    src: url("${getURL("Big+Caslon+Italic.woff2")}") format("woff2"),
      url("${getURL("Big+Caslon+Italic.woff")}") format("woff");
  }
`;

export const CompressedGraphik = css`
  @font-face {
    font-family: "Graphik";
    font-style: normal;
    font-weight: 200;
    src: url("${getURL("Graphik-Regular-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Regular-Web.woff")}") format("woff"),
      url("${getURL("GraphikRegular.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Graphik";
    font-style: italic;
    font-weight: 200;
    src: url("${getURL("Graphik-Regular-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Regular-Web.woff")}") format("woff"),
      url("${getURL("GraphikRegularItalic.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Graphik";
    font-style: normal;
    font-weight: 400;
    src: url("${getURL("Graphik-Medium-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Medium-Web.woff")}") format("woff"),
      url("${getURL("GraphikMedium.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Graphik";
    font-style: italic;
    font-weight: 400;
    src: url("${getURL("Graphik-Medium-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Medium-Web.woff")}") format("woff"),
      url("${getURL("GraphikMediumItalic.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Graphik";
    font-style: normal;
    font-weight: 700;
    src: url("${getURL("Graphik-Semibold-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Semibold-Web.woff")}") format("woff"),
      url("${getURL("GraphikSemiBold.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Graphik";
    font-style: italic;
    font-weight: 700;
    src: url("${getURL("Graphik-Semibold-Web.woff2")}") format("woff2"),
      url("${getURL("Graphik-Semibold-Web.woff")}") format("woff"),
      url("${getURL("GraphikSemiBoldItalic.otf")}") format("opentype");
  }
`;

export const CompressedNantes = css`
  @font-face {
    font-family: "Nantes";
    font-style: normal;
    font-weight: 100;
    src: url("${getURL("NantesWeb-Book.woff2")}") format("woff2"),
      url("${getURL("NantesWeb-Book.woff")}") format("woff"),
      url("${getURL("Nantes-Book.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Nantes";
    font-style: normal;
    font-weight: 300;
    src: url("${getURL("NantesWeb-Book.woff2")}") format("woff2"),
      url("${getURL("NantesWeb-Book.woff")}") format("woff"),
      url("${getURL("Nantes-Book.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Nantes";
    font-style: normal;
    font-weight: 400;
    src: url("${getURL("NantesWeb-Regular.woff2")}") format("woff2"),
      url("${getURL("NantesWeb-Regular.woff")}") format("woff"),
      url("${getURL("Nantes-Regular.otf")}") format("opentype");
  }

  @font-face {
    font-family: "Nantes";
    font-style: normal;
    font-weight: 700;
    src: url("${getURL("NantesWeb-Regular.woff2")}") format("woff2"),
      url("${getURL("NantesWeb-Regular.woff")}") format("woff"),
      url("${getURL("Nantes-Regular.otf")}") format("opentype");
  }
`;

export const CompressedDefaultFonts = css`
  ${BigCaslon}
  ${CompressedGraphik}
  ${CompressedNantes}
`;
